/** PR number from a NADIN vehicle feature entry (`prCoding.prNumber`). */
export function getVehicleOptionPrNumber(option: unknown): string {
  if (typeof option !== "object" || option === null) {
    return "";
  }
  const prCoding = (option as { prCoding?: unknown }).prCoding;
  if (typeof prCoding !== "object" || prCoding === null) {
    return "";
  }
  const prNumber = (prCoding as { prNumber?: unknown }).prNumber;
  return typeof prNumber === "string" ? prNumber : "";
}
